import axios from 'axios'

const DASHER_MOBILE_BFF_URL = 'https://api-dasher.doordash.com/'

export const createDasherRTFRequest = async () => {
  const url = '/v3/dasher/privacy/'
  return await axios.post(url, { request_type: 'RTF' }, { baseURL: DASHER_MOBILE_BFF_URL })
}

export const createDasherRTIRequest = async () => {
  const url = '/v3/dasher/privacy/'
  return await axios.post(url, {}, { baseURL: DASHER_MOBILE_BFF_URL })
}

export const getDasherRTIRequestList = async () => {
  const url = '/v3/dasher/privacy/'
  return await axios.get(url, { baseURL: DASHER_MOBILE_BFF_URL })
}

export const getDasherRTIRequest = async (requestId: string) => {
  const url = `/v3/dasher/privacy/${requestId}`
  return await axios.get(url, { baseURL: DASHER_MOBILE_BFF_URL })
}

export const resendDasherRTIEmail = async (requestId: string) => {
  const url = `/v3/dasher/privacy/${requestId}/resend`
  return await axios.post(url, { baseURL: DASHER_MOBILE_BFF_URL })
}

export const getDasherRTIRequestArchive = async (requestId: string) => {
  const url = `/v3/dasher/privacy/${requestId}/download`
  return await axios.get(url, { baseURL: DASHER_MOBILE_BFF_URL })
}